import { RefObject,useCallback, useRef, useState } from 'react';

import { PinchZoomPanInstance } from '@/components/elements/vendor/PinchZoomPan';

interface UseDocumentZoomResult {
  rotation: number;
  currentScale: number;
  isZoomInDisabled: boolean;
  isZoomOutDisabled: boolean;
  pinchZoomRef: RefObject<PinchZoomPanInstance | null>;
  previewRef: RefObject<HTMLDivElement | null>;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  handleRotate: () => void;
  setRotation: (rotation: number) => void;
  setCurrentScale: (scale: number) => void;
}

const INITIAL_SCALE = 1;
const ZOOM_LEVELS = [INITIAL_SCALE / 1.75, INITIAL_SCALE, INITIAL_SCALE * 1.75, INITIAL_SCALE * 3.0];
const ROTATION_STEP = 90;
const ZOOM_THRESHOLD = 0.001;

export const useDocumentZoom = (): UseDocumentZoomResult => {
  const previewRef = useRef<HTMLDivElement>(null);
  const pinchZoomRef = useRef<PinchZoomPanInstance>(null);
  const [rotation, setRotation] = useState(0);
  const [currentScale, setCurrentScale] = useState(INITIAL_SCALE);

  const isZoomInDisabled = currentScale >= ZOOM_LEVELS[ZOOM_LEVELS.length - 1] - ZOOM_THRESHOLD;
  const isZoomOutDisabled = currentScale <= ZOOM_LEVELS[0] + ZOOM_THRESHOLD;

  const handleZoomIn = useCallback(() => {
    pinchZoomRef.current?.handleZoomInClick();
  }, []);

  const handleZoomOut = useCallback(() => {
    pinchZoomRef.current?.handleZoomOutClick();
  }, []);

  const handleRotate = useCallback(() => {
    setRotation((prev) => prev + ROTATION_STEP);
  }, []);

  return {
    rotation,
    currentScale,
    isZoomInDisabled,
    isZoomOutDisabled,
    pinchZoomRef,
    previewRef,
    handleZoomIn,
    handleZoomOut,
    handleRotate,
    setRotation,
    setCurrentScale,
  };
};
